import { RateLimitService } from './RateLimitService';

class AppRateLimitService extends RateLimitService {
    /**
     * 
     * @param {import('@themost/common').ApplicationBase} app 
     */
    constructor(app) {
        super(app);
    }

    getServiceName() {
        return '@universis/janitor#AppRateLimitService';
    }

    getServiceContainer() {
        return this.getApplication() && this.getApplication().container;
    }
}

export { AppRateLimitService };